import React, { useState } from "react";
import "./TreatementsSection.css";
import story1 from "./media/rootcanal.jpg";
import story2 from "./media/screw.jpg";
import story5 from "./media/dentures1.jpg";
import story12 from "./media/clean.jpg";
import story14 from "./media/cosmetic.jpg";
import story11 from "./media/kids.jpg";
import story7 from "./media/braces.jpg";
import extract from "./media/extract.webp";


const treatments = [
  {
    id: 1,
    title: "Root Canal Treatment",
    short: "Save infected teeth with painless, precision care.",
    description:
      "Our pain-free root canal treatment in Guwahati saves damaged or infected teeth without the discomfort you'd expect. We gently remove infection from inside the tooth, clean and seal it with modern techniques, so you can keep your natural tooth without pain or sensitivity.",
    image: story1,
  },
  {
    id: 2,
    title: "Dental Implants",
    short: "Permanent replacement for missing teeth.",
    description:
      "Restore missing teeth with dental implants in Guwahati that look, feel, and function just like natural teeth.Our implants act as artificial roots, supporting natural-looking crowns so you can chew, smile and speak with complete confidence again.",
    image: story2,
  },
  {
    id: 3,
    title: "Dentures",
    short: "Comfortable, natural-looking replacements to restore your smile and confidence",
    description:
      "Our custom-fitted dentures in Guwahati restore your smile's function and appearance with natural-looking, comfortable results. Whether you need full or partial dentures, we design each one to fit securely and feel effortless in everyday use.",
    image: story5,
  },
  {
    id: 4,
    title: "Teeth Whitening",
    short: "Lift stains and brighten your smile safely.",
    description:
      "In-clinic teeth whitening in Guwahati delivers fast, visible results while keeping your enamel protected and your teeth looking naturally bright.",
    image: story12,
  },
   {
    id: 5,
    title: "Tooth Extraction",
    short: "Safe, gentle removal to protect your oral health and relieve pain.",
    description:
      "Our tooth extraction treatment in Guwahati is performed with precision and care, minimizing discomfort while ensuring a smooth, safe procedure. Whether it's a simple extraction or a more complex case, we prioritize your comfort every step of the way.",
    image: extract,
  },
     {
    id: 6,
    title: "Child Dentistry",
    short: "Gentle, friendly care designed to keep little smiles healthy and confident.",
    description:
      "Gentle, kid-friendly dental care in Guwahati that makes visits stress-free for children and parents alike. Our pediatric dental services focus on prevention, education, and building healthy habits early.",
    image: story11,
  },
       {
    id: 7,
    title: "Cosmetic Dentistry",
    short: "Transform your smile with natural, confidence-boosting enhancements",
    description:
      "Transform your smile with PrimeMax's cosmetic dentistry treatments in Guwahati, from veneers to smile makeovers, designed to enhance your natural teeth while keeping results looking authentic and long-lasting.",
    image: story14,
  },
    {
    id: 8,
    title: "Orthodontic braces",
    short: "Professional orthodontic braces to straighten teeth and improve bite alignment.",
    description:
      "Straighten your smile with confidence through our modern orthodontic treatments in Guwahati, including traditional braces and clear aligners. We create a personalized plan to align your teeth comfortably and effectively, at any age.",
    image: story7,
  },
];

export default function TreatmentsSection() {
  const [index, setIndex] = useState(0);

  const current = treatments[index];

  const goNext = () => {
    setIndex((prev) => (prev + 1) % treatments.length);
  };

  const goPrev = () => {
    setIndex((prev) =>
      prev === 0 ? treatments.length - 1 : prev - 1
    );
  };

  return (
    <section className="treat-section">
      {/* LEFT / CENTER TEXT BLOCK */}
      <div className="treat-text">
        <p className="treat-kicker">Treatments we provide</p>
        <h2 className="treat-heading">{current.title}</h2>

        <div className="treat-divider" />

        <p className="treat-short">{current.short}</p>
        <p className="treat-description">{current.description}</p>

          <div className="meet-buttons">
          <button className="arrow-btn" onClick={goPrev}>
            ←
          </button>
          <button className="arrow-btn" onClick={goNext}>
            →
          </button>
        </div>
        
      </div>

      {/* RIGHT IMAGE SLIDER */}
      <div className="treat-image-shell">
        <div
          className="treat-track"
          style={{ transform: `translateX(-${index * 100}%)` }}
        >
          {treatments.map((treat) => (
            <div className="treat-slide" key={treat.id}>
              <img
                src={treat.image}
                alt={treat.title}
                className="treat-image"
              />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
